import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { SelectProfileImage } from './model';
import { UploadFileView } from 'portcall/uploadfile/view';
import { CropImageView } from 'portcall/cropimage/view';
import * as cx from 'classnames';

export const SelectProfileImageView = SuperCritical(({ modelContainer } : { modelContainer : () => SelectProfileImage | null }) => {
    let m = modelContainer();
    if (!m) return null!;
    return (
        <div className="selectprofileimage pc-card">
            <div className="pc-card-header">
                <span className="pc-card-title">Select Profile Image</span>
                {(m => m &&
                    <a href="" className="done-btn" onClick={noDefault(m.Hide)}>
                        Done
                    </a>
                )(modelContainer())}
            </div>
            <div>
                <label className="img-block upload-new-image" htmlFor={m.FileUploader.FileInputId()}>
                    <a className="file-picker-link">
                        Upload New Image
                    </a>
                    <UploadFileView model={m.FileUploader} />
                </label>
                {m.Image.UploadProfileUrl() &&
                    <div className={cx('img-block uploaded-image', {
                            selected: m.Image.ProfileUrl() === m.Image.UploadProfileUrl()
                        })}>
                        <img src={m.Image.UploadProfileUrl()!} onClick={m.SelectUploadedImage} />
                        <div className="uploaded-image-controls">
                            <a href="" onClick={noDefault(m.CropUploadedImage)}>
                                <span className="glyphicon glyphicon-pencil edit-cropping pc-text-label-color"></span>
                            </a>
                        </div>
                    </div>
                }
                {m.DefaultImages().map(img =>
                    <div className={cx('img-block', {
                            selected: m!.Image.ProfileUrl() === img.Model.ProfileUrl()
                        })} key={img.Model.Id()}>
                        <img src={img.Model.ProfileUrl() || ''} onClick={img.Select} />
                    </div>
                )}
                <CropImageView modelContainer={m.ImageCropper} />
            </div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/selectprofileimage/view.tsx